import React from "react";
import ExclusionRulesContent from "../components/exclusionRules/exclusionRules-content";

const ExclusionRules = () => {
  return <ExclusionRulesContent />;
};

export default ExclusionRules;
